import type { FC, ReactNode } from 'react'

import { useEffect, useState } from 'react'

import { studio } from '@/constants/site'

/** Local studio time. Rendered only after mount so the server and client agree. */
export const LocalTime: FC = (): ReactNode => {
    const [time, setTime] = useState<string | null>(null)

    useEffect(() => {
        const tick = () => {
            setTime(
                new Intl.DateTimeFormat('en-GB', {
                    hour: '2-digit',
                    minute: '2-digit',
                    hour12: false,
                    timeZone: studio.timeZone
                }).format(new Date())
            )
        }

        tick()
        const id = window.setInterval(tick, 30_000)

        return () => {
            window.clearInterval(id)
        }
    }, [])

    return <span className='tabular-nums'>{time ?? '--:--'}</span>
}
